import React from 'react';
import {connect} from "react-redux";
import {Trans} from "react-i18next";
import BsPanelLoader from "components/panel/loader/BsPanelLoader";
import BsPanelHeader from "components/panel/header/BsPanelHeader";
import BsDataTable from "components/data-table/BsDataTable";
import BsPanelTitle from "components/panel/header/BsPanelTitle";
import BsTabPanel from "components/panel/BsTabPanel";
import GENERAL_BICYCLE_PROBLEMS_TABLE from "./general-bicycle-problems-table";
import {exportAllMaintenanceToCsv, loadAllMaintenanceIssue} from "core/actions/maintenance-actions";
import Button from "@material-ui/core/Button";

const queryString = require('query-string');

class GeneralBicycleProblemsTab extends React.Component {

  constructor(props) {
    super(props);
    const query = queryString.parse(this.props.location.search);
    this.state = {
      sort: query.sort,
      direction: query.direction
    };

    this.onLoadData(query);
  }

  onRequestSort = (params) => {
    this.setState({
      sort: params.sort,
      direction: params.direction
    });
    this.onLoadData(params);
  }

  onLoadData = (query) => {
    this.props.loadAllMaintenanceIssue(this.prepareQuery(query));
  }

  onRowClick = (row) => {
    this.props.history.push('/global/bicycle-info/' + this.props.match.params.bicycleId + '/reported-problem/' + row.id)
  }

  export = () => {
    const query = queryString.parse(this.props.location.search);
    this.props.exportAllMaintenanceToCsv(this.prepareQuery(query));
  }

  prepareQuery = (query) => {
    if (query.sort) {
      query.sort = query.sort + ',' + query.direction;
    }
    query['bike.id'] = this.props.match.params.bicycleId

    return query
  }

  render() {
    return (
        <BsTabPanel>
          <BsPanelLoader show={this.props.loading}/>
          <BsPanelHeader>
            <BsPanelTitle action={
              <Button variant="outlined" type="button" onClick={this.export}>
                <Trans i18nKey="general.export"/>
              </Button>
            }>
            </BsPanelTitle>
          </BsPanelHeader>

          <BsDataTable location={this.props.location}
                       history={this.props.history}
                       order={this.state.direction}
                       orderBy={this.state.sort}
                       settings={GENERAL_BICYCLE_PROBLEMS_TABLE}
                       content={this.props.issues}
                       onRowClick={this.onRowClick}
                       onChangePage={this.onLoadData}
                       onChangeSize={this.onLoadData}
                       onRequestSort={this.onRequestSort}/>
        </BsTabPanel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    issues: state.maintenance.allIssues,
    loading: state.clientUser.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadAllMaintenanceIssue: (query) => {
      dispatch(loadAllMaintenanceIssue(query));
    },
    exportAllMaintenanceToCsv: (query) => {
      dispatch(exportAllMaintenanceToCsv(query));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralBicycleProblemsTab);
